import { PrecentileRankService } from "../service/asyncBatchPercentileRankService";
import * as validations from "../utils/validations";

export class PercentileRankFunctions {
  fnBurgissUniverseRankIRR(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }
    dynamicParameter = validations.validDynamicParameter(dynamicParameter);
    if (String(dynamicParameter).includes("Error")) {
      let str = String(dynamicParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    peerGroupId = peerGroupId == null || peerGroupId == "" ? "" : peerGroupId.toString();
    return new PrecentileRankService().burgissUniverseRankIRR(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      uniqueCellId
    );
  }
  fnBurgissUniverseRankDPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }
    dynamicParameter = validations.validDynamicParameter(dynamicParameter);
    if (String(dynamicParameter).includes("Error")) {
      let str = String(dynamicParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    peerGroupId = peerGroupId == null || peerGroupId == "" ? "" : peerGroupId.toString();
    return new PrecentileRankService().burgissUniverseRankDPI(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      uniqueCellId
    );
  }
  fnBurgissUniverseRankTVPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }
    dynamicParameter = validations.validDynamicParameter(dynamicParameter);
    if (String(dynamicParameter).includes("Error")) {
      let str = String(dynamicParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    peerGroupId = peerGroupId == null || peerGroupId == "" ? "" : peerGroupId.toString();
    return new PrecentileRankService().burgissUniverseRankTVPI(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      uniqueCellId
    );
  }
  fnBurgissUniverseRankRVPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }
    dynamicParameter = validations.validDynamicParameter(dynamicParameter);
    if (String(dynamicParameter).includes("Error")) {
      let str = String(dynamicParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }
    peerGroupId = peerGroupId == null || peerGroupId == "" ? "" : peerGroupId.toString();
    return new PrecentileRankService().burgissUniverseRankRVPI(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      uniqueCellId
    );
  }
}
